import React, { useCallback, useEffect, useState } from "react";
import { Row, Col, Form, Button, Image } from "react-bootstrap";
import "./index.css";
import "./userCompanyInfo.css";
import CustomButton from "../../../common/CustomButton";
import { useSelector, useDispatch } from "react-redux";
import { getApi, patchCompanyInfo, postGetGSTPrice } from "../../../../actions/structure.action";
import isEmpty from "../../../../utils/is-Empty";
import { capitalize, debounce } from "lodash";
import CustomSelectDropdown from "../../../common/CustomSelectDropdown";
import FilterObjectsByKeyValue from "../../../../utils/FilterObjectsByKeyValue";
import { paymenttypesString } from "../../../../helpers/table-structures";
import { getUserCompanyInfo, patchUserCompanyInfo } from "../../../../actions/user.actions";
import PageSpinner from "../../../common/PageSpinner";
import { stringConstants } from "../../../../helpers";
import { useDialog } from "../../../../helpers/useDialog";
import { toast } from "react-toastify";

const UserCompanyInfo = ({ title = "Company Info", userId, userObj }) => {
  const dispatch = useDispatch();
  const { alert, confirm, DialogModal } = useDialog();
  const [errorMsg, setErrorMsg] = useState("");
  const [companyInfo, setCompanyInfo] = useState({});
  const [loading, setLoading] = useState(false);
  const [isUpdateMode, setIsUpdateMode] = useState(false);
  const [uploadFormObj, setUploadFormObj] = useState({});
  const [file, setFile] = useState(null);
  const { requestCall, bhareeAdminBasicTable } = useSelector((state) => {
    return state;
  });

  useEffect(() => {
    callGetUserCompanyInfoAPI(userId, dispatch);
  }, [dispatch, userId]);

  useEffect(() => {
    setIsUpdateMode(false);
    if (!isEmpty(companyInfo?.data)) {
      setUploadFormObj(companyInfo?.data);

      const deliveryChargeWithoutGST =
        parseFloat(companyInfo?.data?.business_info?.deliveryCharge || 0) / 1.18;
      const handlingChargesWithoutGST =
        parseFloat(companyInfo?.data?.business_info?.handling_charges || 0) / 1.18;

      setUpdatedForm("business_name", companyInfo?.data?.business_info?.business_name);
      setUpdatedForm("gst_no", companyInfo.data?.business_info?.gst_no);
      setUpdatedForm("deliveryCharge", deliveryChargeWithoutGST.toFixed(2));
      setUpdatedForm("deliveryChargeFinal", companyInfo.data?.business_info?.deliveryCharge);
      setUpdatedForm("handling_charges", handlingChargesWithoutGST.toFixed(2));
      setUpdatedForm("handlingChargesFinal", companyInfo.data?.business_info?.handling_charges);
      setUpdatedForm("payment_types", companyInfo?.data?.business_info?.payment_types);
    }
  }, [companyInfo]);

  const callGetUserCompanyInfoAPI = (mUserId, dispatch) => {
    setLoading(true);
    getUserCompanyInfo(mUserId, dispatch)
      .then((res) => {
        setCompanyInfo(res);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const setUpdatedForm = (key, value) => {
    let updatedObj = {};
    updatedObj[key] = value;

    setUploadFormObj((previousValues) => ({
      ...previousValues,
      ...updatedObj,
    }));
  };

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile && selectedFile.size > 2 * 1024 * 1024) {
      setErrorMsg("❌ File size must be ≤ 2MB");
      return;
    }
    setFile(selectedFile);
    setErrorMsg("");
  };

  const updateCompanyInfo = (e) => {
    e.preventDefault();
    setErrorMsg("");
    console.log("Upload Form Obj: ", uploadFormObj);

    if (companyInfo?.data?.roleName === stringConstants.ROLL_SELLER) {
      if (
        !isEmpty(uploadFormObj) &&
        !isEmpty(uploadFormObj?.contact_person_name) &&
        !isEmpty(uploadFormObj?.gst_no) &&
        !isEmpty(uploadFormObj?.business_name) &&
        !isEmpty(uploadFormObj?.mobile_number) &&
        !isEmpty(uploadFormObj?.email) &&
        !isEmpty(uploadFormObj?.deliveryCharge) &&
        !isEmpty(uploadFormObj?.payment_types)
      ) {
        let formData = new FormData();
        formData.append("contactPerson", uploadFormObj.contact_person_name);
        formData.append("gst", uploadFormObj.gst_no);
        formData.append("deliveryCharge", uploadFormObj.deliveryChargeFinal);
        formData.append("handling_charges", uploadFormObj.handlingChargesFinal);
        formData.append("business_name", uploadFormObj.business_name);
        formData.append("mobile_number", uploadFormObj.mobile_number);
        formData.append("email", uploadFormObj.email);
        if (!isEmpty(uploadFormObj.payment_types)) {
          console.log("uploadFormObj.payment_types : ", uploadFormObj.payment_types);
          const idsString = uploadFormObj.payment_types.map((item) => item.id).join(",");
          formData.append("payment_types", idsString);
        }
        // 👇 Add signature file if selected
        if (file) {
          formData.append("signature", file);
        }
        if (isUpdateMode) {
          if (isEmpty(uploadFormObj?.business_info?.authorized_signature) && !file) {
            setErrorMsg("Please upload authorized signature.");
          } else {
            setLoading(true);
            patchUserCompanyInfo(userId, formData, dispatch)
              .then((res) => {
                if (res.success) {
                  toast.success(res.message);
                  setIsUpdateMode(false);
                  callGetUserCompanyInfoAPI(userId, dispatch);
                } else {
                  setLoading(false);
                }
              })
              .finally(() => {
                setLoading(false);
              });
          }
        }
      }
    } else if (companyInfo?.data?.roleName === stringConstants.ROLL_BUYER) {
      if (
        !isEmpty(uploadFormObj) &&
        !isEmpty(uploadFormObj?.contact_person_name) &&
        !isEmpty(uploadFormObj?.gst_no) &&
        !isEmpty(uploadFormObj?.business_name) &&
        !isEmpty(uploadFormObj?.mobile_number) &&
        !isEmpty(uploadFormObj?.email)
      ) {
        let formData = new FormData();
        formData.append("contactPerson", uploadFormObj.contact_person_name);
        formData.append("gst", uploadFormObj.gst_no);
        formData.append("business_name", uploadFormObj.business_name);
        formData.append("mobile_number", uploadFormObj.mobile_number);
        formData.append("email", uploadFormObj.email);
        if (isUpdateMode) {
          setLoading(true);
          patchUserCompanyInfo(userId, formData, dispatch)
            .then((res) => {
              if (res.success) {
                toast.success(res.message);
                setIsUpdateMode(false);
                callGetUserCompanyInfoAPI(userId, dispatch);
              } else {
                setLoading(false);
              }
            })
            .finally(() => {
              setLoading(false);
            });
        }
      }
    }
  };

  const companyInfoView = () => {
    return (
      <Row className="company-info m-0">
        <Row className="heading-div">
          <Col md={6} xs={6} className="m-0 p-0">
            <h5 className="text-uppercase p-0 m-0">
              Business Name: {companyInfo?.data?.business_info?.business_name}
            </h5>
          </Col>
          <Col md={6} xs={6} className="m-0 p-0 text-end">
            <Button
              className="btn-theme"
              size="sm"
              onClick={() => {
                setIsUpdateMode(true);
              }}
            >
              <i className="bi bi-pencil"></i> Edit
            </Button>
          </Col>
        </Row>
        <hr />
        <Row className="m-0 p-0">
          <Col xs={12} md={6} lg={4} className="p-0">
            <p>
              <span>{"Contact Person:"}</span>
              <span className="mx-2 bold-span"> {companyInfo?.data?.contact_person_name}</span>
            </p>
          </Col>
          <Col xs={12} md={6} lg={4} className="p-0">
            <p>
              <span>{"Email:"}</span>
              <span className="mx-2 bold-span"> {companyInfo?.data?.email}</span>
            </p>
          </Col>
          <Col xs={12} md={6} lg={4} className="p-0">
            <p>
              <span>{"Mobile Number:"}</span>
              <span className="mx-2 bold-span">{companyInfo?.data?.mobile_number}</span>
            </p>
          </Col>
          <Col xs={12} md={6} lg={4} className="p-0">
            <p>
              <span>{`${capitalize(companyInfo?.data?.roleName)} Category:`}</span>
              <span className="mx-2 bold-span">{capitalize(companyInfo?.data?.roleTypeName)}</span>
            </p>
          </Col>
          <Col xs={12} md={6} lg={4} className="p-0">
            <p>
              <span>{"GST:"}</span>
              <span className="mx-2 bold-span">{companyInfo?.data?.business_info?.gst_no}</span>
            </p>
          </Col>

          {/* Seller related */}
          {userObj?.role?.role_name === stringConstants.ROLL_SELLER && (
            <>
              <Col xs={12} md={6} lg={4} className="p-0">
                <p>
                  <span>{"Delivery Charges (Per Case):"}</span>
                  <span className="mx-2 bold-span">
                    <i className="bi bi-currency-rupee"></i>
                    {companyInfo?.data?.business_info?.deliveryCharge
                      ? parseFloat(companyInfo?.data?.business_info?.deliveryCharge).toFixed(2)
                      : 0.0}
                  </span>
                </p>
              </Col>
              <Col xs={12} md={6} lg={4} className="p-0">
                <p>
                  <span>{"Handling Charges (Per Case):"}</span>
                  <span className="mx-2 bold-span">
                    <i className="bi bi-currency-rupee"></i>
                    {companyInfo?.data?.business_info?.handling_charges}
                  </span>
                </p>
              </Col>
              <Col xs={12} md={6} lg={4} className="p-0">
                <p>
                  <span>{"Payment Types:"}</span>
                  <span className="mx-2 bold-span">
                    {paymenttypesString(companyInfo?.data?.business_info?.payment_types)}
                  </span>
                </p>
              </Col>
              <Col xs={12} md={6} lg={4} className="p-0">
                <p>
                  <span>{"Onboarding:"}</span>
                  <span
                    className={`mx-2 bold-span ${
                      companyInfo?.data?.onboarding ? "text-success" : "text-danger"
                    }`}
                  >
                    {companyInfo?.data?.onboarding ? "Completed" : "In Progress"}
                  </span>
                </p>
              </Col>
            </>
          )}
        </Row>
        {/* Seller related */}
        {userObj?.role?.role_name === stringConstants.ROLL_SELLER && (
          <Row className="m-0 p-0">
            <Col xs={12} md={12} className="px-0">
              <h5 className="text-uppercase p-0 m-0 mt-3 small">Authorized Signature</h5>
              {(() => {
                if (companyInfo?.data?.business_info?.authorized_signature) {
                  return (
                    <Image
                      className="img-fluid"
                      src={companyInfo?.data?.business_info?.authorized_signature}
                      alt="Authorized Signature"
                      style={{ height: "100px" }}
                    />
                  );
                } else {
                  return (
                    <p className="text-danger small px-0 mt-2 m-0">
                      Please upload authorized signature by clicking on the "Edit" button. This
                      signature will be shown in the invoice.
                    </p>
                  );
                }
              })()}
            </Col>
          </Row>
        )}
      </Row>
    );
  };

  const handleCalculateDeliveryCharge = (e) => {
    const value = e.target.value;
    // Add your calculation logic here
    console.log("Calculating delivery charge for value:", value);
    debouncedUpdatePrice(value, "deliveryChargeFinal");
  };

  const handleCalculateHandlingCharges = (e) => {
    const value = e.target.value;
    // Add your calculation logic here
    console.log("Calculating handling charges for value:", value);
    debouncedUpdatePrice(value, "handlingChargesFinal");
  };

  const debouncedUpdatePrice = useCallback(
    debounce((value, fieldName) => {
      let obj = {};
      obj["price"] = value;
      postGetGSTPrice(obj, dispatch).then((res) => {
        if (res && res.data) {
          // Handle the response data as needed
          console.log("Calculated Price Data:", res.data);
          if (res.data.success) {
            setUpdatedForm(fieldName, res.data.data.gstAmount.toFixed(2));
          }
        }
      });
    }, 1000), // Adjust delay as needed
    [],
  );

  const companyInfoEdit = () => {
    return (
      <Row className="m-0 w-full form-row">
        <Form className=" modal-custom-class" onSubmit={updateCompanyInfo}>
          <Row className="m-0 mb-2 title-button-row">
            <Col md={6} xs={6} className="m-0 p-0">
              <h2>{!isUpdateMode ? `${title}` : `Update ${title}`}</h2>
            </Col>
            <Col md={6} xs={6} className="m-0 p-0 text-end">
              <Button
                className="btn-theme"
                size="sm"
                onClick={() => setIsUpdateMode(!isUpdateMode)}
              >
                <i className="bi bi-eye"></i> {!isUpdateMode ? "Edit" : "View"}
              </Button>
            </Col>
          </Row>
          <Row className="m-0">
            <Col xs={12} sm={12} md={6} className="form-col ">
              <Form.Group className="mb-3">
                <Form.Label>
                  {"Business Name"}
                  <span className="redStreSpan">{"*"}</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  value={uploadFormObj?.business_name ?? ""}
                  placeholder="*_*"
                  onChange={(e) => setUpdatedForm("business_name", e.target.value)}
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>
                  {"Mobile Number"}
                  <span className="redStreSpan">{"*"}</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  value={!isEmpty(uploadFormObj) ? uploadFormObj.mobile_number : "*_*"}
                  // onChange={(e) => setUpdatedForm("mobile_number", e.target.value)}
                  disabled
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>
                  {"GST"}
                  <span className="redStreSpan">{"*"}</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  value={!isEmpty(uploadFormObj) ? uploadFormObj?.gst_no : "*_*"}
                  onChange={(e) => setUpdatedForm("gst_no", e.target.value)}
                  disabled={!isUpdateMode}
                />
              </Form.Group>
              {companyInfo?.data?.roleName === stringConstants.ROLL_SELLER && (
                <>
                  <Form.Group className="mb-3">
                    <Form.Label>
                      {"Delivery Charges (Per Case)"}
                      <span className="redStreSpan">{"*"}</span>
                      <span className="positiveMsg pointer">
                        {` Final (with 18% GST): ₹ ${uploadFormObj?.deliveryChargeFinal}`}
                      </span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      value={!isEmpty(uploadFormObj) ? uploadFormObj?.deliveryCharge : ""}
                      onChange={(e) => {
                        setUpdatedForm("deliveryCharge", e.target.value);
                        handleCalculateDeliveryCharge(e);
                      }}
                      disabled={!isUpdateMode}
                    />
                    <p className="m-0 p-0 text-danger small">
                      * Delivery charges should be entered without GST
                    </p>
                  </Form.Group>
                  <Form.Group className="mb-3">
                    <Form.Label>
                      {"Handling Charges (Per Case)"}
                      <span className="redStreSpan">{"*"}</span>
                      <span className="positiveMsg pointer">
                        {` Final (with 18% GST): ₹ ${uploadFormObj?.handlingChargesFinal}`}
                      </span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      value={!isEmpty(uploadFormObj) ? uploadFormObj?.handling_charges : ""}
                      onChange={(e) => {
                        setUpdatedForm("handling_charges", e.target.value);
                        handleCalculateHandlingCharges(e);
                      }}
                      disabled={!isUpdateMode}
                    />
                    <p className="m-0 p-0 text-danger small">
                      * Handling charges should be entered without GST
                    </p>
                  </Form.Group>
                </>
              )}
            </Col>
            <Col xs={12} sm={12} md={6} className="form-col ">
              <Form.Group className="mb-3">
                <Form.Label>
                  {"Email"}
                  <span className="redStreSpan">{"*"}</span>
                </Form.Label>
                <Form.Control
                  type="email"
                  value={!isEmpty(uploadFormObj) ? uploadFormObj.email : "*_*"}
                  // onChange={(e) => setUpdatedForm("email", e.target.value)}
                  disabled
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>
                  {`${capitalize(uploadFormObj?.roleName)} Category`}
                  <span className="redStreSpan">{"*"}</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  value={!isEmpty(uploadFormObj) ? capitalize(uploadFormObj.roleTypeName) : "*_*"}
                  disabled
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>
                  {"Contact Person"}
                  <span className="redStreSpan">{"*"}</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  value={!isEmpty(uploadFormObj) ? uploadFormObj["contact_person_name"] : "*_*"}
                  onChange={(e) => setUpdatedForm("contact_person_name", e.target.value)}
                  disabled={!isUpdateMode}
                />
              </Form.Group>
              {companyInfo?.data?.roleName === stringConstants.ROLL_SELLER &&
                bhareeAdminBasicTable?.data?.paymentTypes?.length > 0 && (
                  <Form.Group className="mb-3" controlId="formBasicEmail">
                    <Form.Label>
                      {"Select Payment Types"}
                      <span className="redStreSpan">{"*"}</span>
                    </Form.Label>
                    <CustomSelectDropdown
                      style={{
                        multiselectContainer: {
                          backgroundColor: "#f8f8f8",
                        },
                        chips: {
                          background: "#fbb040",
                          margin: 0,
                        },
                        option: {
                          background: "#fbb040",
                          color: "#FFFFFF",
                          borderBottom: "1px solid #FFFFFF",
                        },
                      }}
                      options={bhareeAdminBasicTable?.data?.paymentTypes}
                      onRemove={(e) => setUpdatedForm("payment_types", e)}
                      onSelect={(e) => setUpdatedForm("payment_types", e)}
                      selectedValues={uploadFormObj?.business_info?.payment_types}
                      displayValue={"name"}
                    />
                  </Form.Group>
                )}
            </Col>
          </Row>
          {companyInfo?.data?.roleName === stringConstants.ROLL_SELLER && (
            <Row className="m-0">
              <Col xs={12} md={6}>
                <Form.Group controlId="formFile" className="mb-3">
                  <Form.Label>
                    Upload Signature (PNG/JPG ≤ 2MB)<span className="redStreSpan">{"*"}</span>
                  </Form.Label>
                  {uploadFormObj?.business_info?.authorized_signature && (
                    <>
                      <br />
                      <Image
                        className="img-fluid"
                        src={companyInfo?.data?.business_info?.authorized_signature}
                        alt="Authorized Signature"
                        style={{ height: "100px" }}
                      />
                    </>
                  )}
                  <Form.Control
                    type="file"
                    accept="image/*"
                    onChange={handleFileChange}
                    className="custom-file-input"
                  />
                </Form.Group>
              </Col>
            </Row>
          )}

          {errorMsg && <p className="error-msg">{errorMsg}</p>}
          <div className="action-buttons">
            {isUpdateMode && (
              <>
                <CustomButton
                  variant="primary"
                  buttonClasses={"close-btn"}
                  loading={requestCall?.loading}
                  onClick={() => setIsUpdateMode(false)}
                >
                  <i className="bi bi-x-lg"></i> {"close"}
                </CustomButton>
                <CustomButton
                  variant="primary"
                  buttonClasses={!requestCall?.loading ? "submit-btn" : "submit-btn-loading"}
                  type="submit"
                  loading={requestCall?.loading}
                >
                  <i className="bi bi-floppy"></i> {"update"}
                </CustomButton>
              </>
            )}
          </div>
        </Form>
      </Row>
    );
  };

  return (
    <>
      {DialogModal}
      {loading && <PageSpinner />}
      <div className="p-0 company-info-container">
        {(() => {
          if (!isEmpty(companyInfo?.data)) {
            if (!isUpdateMode) {
              if (companyInfo?.data?.roleName === stringConstants.ROLL_SELLER) {
                return companyInfoView();
              } else if (companyInfo?.data?.roleName === stringConstants.ROLL_BUYER) {
                return companyInfoView();
              } else {
                return <p className="m-0 p-0">Other User Information will come over here...</p>;
              }
            } else {
              if (companyInfo?.data?.roleName === stringConstants.ROLL_SELLER) {
                return companyInfoEdit();
              } else if (companyInfo?.data?.roleName === stringConstants.ROLL_BUYER) {
                return companyInfoEdit();
              } else {
                return <p className="m-0 p-0">Other User Edit Form will come over here...</p>;
              }
            }
          }
        })()}
      </div>
    </>
  );
};

export default UserCompanyInfo;
